import { Expression } from '../../types';

type Operators = 'text_contain' | 'in';

export default function expressionFormatter(
  field: string, operator: Operators, { value }: Expression,
): Expression {
  return { field, operator, value };
}
